import React from 'react'

//* Components
import Pagination from '../../global/pagination'
import SEOTags from '../../global/seoTags'
import SubscribeModal from '../../global/subscribeModal'
import GlobalContainer from '../globalContainer'

//* Styles
import { BlogListingOuter, PaginationContainer } from './style'

//* Helpers
import { correctSlugPrefix } from '../../../utils/link.utils'
import { FirstPage } from './subcomponents/firstPage'
import { Listing } from './subcomponents/listing'

type BlogListingProps = {
  posts?: any
  slug: string
  seoData?: any
  totalPages: string
  pageNumber: string
  collectionRowData?: any
  subscribe?: any
  numListingPages: number
  blogFRData?: any
  locale: string
  disableListingTitle?: boolean
  listingTitle?: string
  isMainBlog?: boolean
  microcopyTextListingTitle?: string
}

const BlogListing = ({
  posts,
  slug,
  totalPages,
  pageNumber,
  seoData,
  collectionRowData,
  subscribe,
  numListingPages,
  blogFRData,
  locale,
  disableListingTitle,
  listingTitle,
  isMainBlog,
  microcopyTextListingTitle,
}: BlogListingProps) => {
  if (!posts) return null

  //* If blog featured resource is set, total listings per page should be 13 to accommadate for the featured resource slot
  const articlesPerPage = blogFRData ? 13 : 14
  const currentPage = parseInt(pageNumber)

  const hrefForPage = (page: number) => {
    const slugLink = correctSlugPrefix(slug)
    const url = page === 1 ? slugLink : `${slugLink}/${page}`
    return url
  }

  //* only used internally not by the paging system
  const handlePaginationClick = (page: number) => {
    if (page > 1) {
      history.pushState(null, '', `/${slug}/${page}`)
    } else {
      history.pushState(null, '', `/${slug}`)
    }

    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <BlogListingOuter data-cy="blogListing" $pageNumber={pageNumber}>
      <SEOTags
        seoMetadata={seoData}
        slug={slug}
        path={slug}
        isPaginated={true}
        pageNum={currentPage}
        hrefForPage={hrefForPage}
        isLastPage={currentPage === numListingPages}
      />

      <GlobalContainer>
        {currentPage === 1 && !disableListingTitle && (
          <FirstPage
            listingTitle={listingTitle || ''}
            isMainBlog={isMainBlog || false}
            disableListingTitle={disableListingTitle || false}
            microcopyTextListingTitle={microcopyTextListingTitle || ''}
          />
        )}

        <Listing
          posts={posts}
          isMainBlog={isMainBlog || false}
          locale={locale}
          blogFRData={blogFRData}
          subscribe={subscribe}
          collectionRowData={collectionRowData}
          pageNumber={pageNumber}
        />

        {parseInt(totalPages) / articlesPerPage > 1 && (
          <PaginationContainer>
            <Pagination
              activePage={currentPage}
              hrefForPage={hrefForPage}
              handleClick={handlePaginationClick}
              numResults={parseInt(totalPages)}
              numPagesBeforeEllipses={3}
              numResultsPerPage={articlesPerPage}
              numPages={numListingPages ? numListingPages : undefined}
            />
          </PaginationContainer>
        )}
      </GlobalContainer>

      {subscribe && <SubscribeModal data={subscribe} />}
    </BlogListingOuter>
  )
}

export default BlogListing
